import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiClientService } from '../../../core/api-client.service';

type ApiResponse = { success?: boolean; result?: boolean; message?: string; data?: Record<string, any> };

@Injectable({ providedIn: 'root' })
export class AdminSupportService {
  private readonly api = inject(ApiClientService);

  data(threadID?: number) { return this.call('adminSupportData', threadID ? { threadID } : {}); }
  messages(page = 0, senderType = '') { return this.call('adminSupportMessages', { page, senderType }); }
  templates() { return this.call('adminSupportTemplates'); }
  reply(threadID: number, message: string) { return this.call('adminSupportReply', { threadID, message }); }
  createTicket(userID: number, message: string, priority = 'LOW') { return this.call('adminSupportCreate', { userID, message, priority }); }
  prepareLeaves() { return this.call('adminSupportPrepareLeaves'); }
  saveTemplate(payload: Record<string, unknown>) { return this.call('adminSupportTemplateSave', payload); }
  deleteTemplate(id: number) { return this.call('adminSupportTemplateDelete', { id }); }

  private async call(endpoint: string, payload: Record<string, unknown> = {}) {
    const response = await firstValueFrom(this.api.post<ApiResponse>(endpoint, payload));
    if (!response.success && !response.result) throw new Error(response.message || 'İşlem tamamlanamadı.');
    return response.data ?? {};
  }
}
